import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { WorkbenchModule } from '@workbench/angular';
@NgModule({
    declarations: [],
    imports: [WorkbenchModule],
    exports: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  })
  export class SharedModule { }
